import { Component } from '@angular/core';

@Component({
    selector: 'balances-details-childrows',
    templateUrl: './balances-details-childrows.component.html'
})
export class BalancesDetailsChildrowsComponent  {
    data: any;
    showThreeColumns: boolean = false;
    naForBrokerage: boolean = false;
    naForCustodian: boolean = false;

    agInit(params: any): void {
        this.data = params.data;
        this.showThreeColumns = this.data !== undefined && this.data !== null && this.data.valuec !== undefined && this.data.valuec !== null;
        // Check if children exist and if any their value is of null or undefined then consider it's not applicable.
        this.naForBrokerage = this.data.children && this.data.children.length > 0 &&
            this.data.children.some((c: any) => { return c.value === null || typeof c.value === 'undefined'; });
        this.naForCustodian = this.data.children && this.data.children.length > 0 &&
            this.data.children.some((c: any) => { return c.valuec === null || typeof c.valuec === 'undefined'; });
    }

    public  isNumber(value: string | number): boolean
    {
   return ((value != null) &&
           (value !== '') &&
           !isNaN(Number(value.toString())));
    }
}
